module.exports = __webpack_public_path__ + "img/HOMEOPATIA.a8d00703.png";